import React from "react";
import PropTypes from "prop-types";
import { Flex, Box } from "grid-styled";
import { withRouter } from "react-router-dom";
import Modal from "./Modal";
import Button from "./Button";
import AttachmentsSection from "./AttachmentsSection";
import CenteredLoader from "./CenteredLoader";
import { ATTACHMENT_TYPES } from "../constants";

class Attachments extends React.Component {
  static propTypes = {
    data: PropTypes.shape({
      loading: PropTypes.bool,
      error: PropTypes.any,
      attachments: PropTypes.array
    })
  };

  constructor(props) {
    super(props);
    this.state = {
      deletingAttachment: null
    };
  }

  handleFileDrop = (props, monitor) => {
    if (monitor) {
      this.props.addFiles(monitor.getItem().files, props.type);
    }
  };

  markAttachmentForDeletion = attachment => {
    this.setState({ deletingAttachment: attachment });
  };

  renderSections = () => {
    const { dropTypes } = this.props;
    return ATTACHMENT_TYPES.map(type => {
      const sectionAttachments = this.props.data.attachments.filter(
        attachment => attachment.attachmentType === type.value
      );

      if (
        sectionAttachments.length === 0 &&
        !dropTypes.some(dt => dt.value === type.value)
      ) {
        return null;
      }

      const required = !(
        this.props.requirements.find(req => req.type === type.value) || {
          complete: true
        }
      ).complete;

      return (
        <AttachmentsSection
          key={type.value}
          title={type.collection}
          type={type.value}
          match={this.props.match}
          history={this.props.history}
          deleteAttachment={this.markAttachmentForDeletion}
          dropTypes={this.props.dropTypes}
          attachments={sectionAttachments}
          onDrop={this.handleFileDrop}
          onClick={this.props.handleSectionClick(type.value)}
          required={required}
        />
      );
    });
  };

  deleteAttachment = () => {
    const attachment = this.state.deletingAttachment;
    this.props
      .deleteAttachment(attachment)
      .then(() => {
        this.setState({ deletingAttachment: null });
      })
      .catch(err =>
        console.log("Error occurred while deleting attachment", err)
      );
  };

  renderAttachmentDeletionModal = () => {
    const attachment = this.state.deletingAttachment;

    return (
      <Modal
        title="Deleting attachment..."
        isOpen={!!attachment}
        close={() => this.setState({ deletingAttachment: null })}
      >
        <Box p={2}>
          <p>
            Are you sure you want to delete{" "}
            <b>{attachment ? attachment.name : "this attachment"}</b>?
          </p>
          <Flex justify="flex-end">
            <Button
              type="button"
              variant="danger"
              onClick={this.deleteAttachment}
            >
              Delete attachment
            </Button>
          </Flex>
        </Box>
      </Modal>
    );
  };

  render() {
    const { data: { loading, attachments } } = this.props;

    if (loading && !attachments) {
      return <CenteredLoader />;
    }

    return (
      <Box pt={2}>
        {this.renderSections()}
        {this.renderAttachmentDeletionModal()}
      </Box>
    );
  }

  static propTypes = {
    uploads: PropTypes.object,
    addFiles: PropTypes.func.isRequired,
    data: PropTypes.shape({
      loading: PropTypes.bool.isRequired,
      refetch: PropTypes.func.isRequired,
      attachments: PropTypes.array
    })
  };
}

export default withRouter(Attachments);



// WEBPACK FOOTER //
// ./src/components/Attachments.js